import { isNumber } from "lodash";
import { theme } from "uikit";

import { DateFns } from "../../../../../../../utils/DateFns";

function formatDuration(milliseconds: number): string {
	if (!isNumber(milliseconds) || Number.isNaN(milliseconds)) return "";

	const sign = Math.sign(milliseconds);
	const abs = Math.abs(milliseconds);

	const seconds = Math.floor((abs / 1e3) % 60);
	const minutes = Math.floor((abs / (1e3 * 60)) % 60);
	const hours = Math.floor((abs / (1e3 * 60 * 60)) % 24);
	const days = Math.floor(abs / (1e3 * 60 * 60 * 24));

	const formatted = `${days ? `${days}Д ` : ""}${String(hours).padStart(
		2,
		"0",
	)}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
	return sign < 0 ? `-${formatted}` : formatted;
}

const cellProcessing = (
	item: {
		orderId?: number;
		withClients: boolean;
		arrivalTime?: number;
	},
	dateFns?: DateFns,
	currentTime?: Date,
) => {
	if (!item?.orderId || !dateFns || !currentTime)
		return {
			content: "",
			backgroundColor: undefined,
			textColor: undefined,
		};
	const { withClients, arrivalTime } = item;

	const content =
		arrivalTime !== undefined ? formatDuration(arrivalTime) : "";
	let backgroundColor: string | undefined;
	if (withClients) backgroundColor = "#4CAF50";
	else if (arrivalTime !== undefined && arrivalTime < 0)
		backgroundColor = "#E8807F";

	const textColor =
		arrivalTime !== undefined && arrivalTime < 0
			? theme.colors.white
			: undefined;

	return { content, backgroundColor, textColor };
};

export default cellProcessing;
